// reducer.js
import {
  FETCH_DAILY_REPORTS_REQUEST,
  FETCH_DAILY_REPORT_REQUEST,
  FETCH_REPORT_TECHNICIAN_REQUEST,
  FETCH_REPORT_STATUS_REQUEST,

  FETCH_DAILY_REPORTS_SUCCESS,
  FETCH_DAILY_REPORT_SUCCESS,
  FETCH_REPORT_TECHNICIAN_SUCCESS,
  FETCH_REPORT_STATUS_SUCCESS,

  FETCH_DAILY_REPORTS_FAILURE,
  FETCH_DAILY_REPORT_FAILURE,
  FETCH_REPORT_TECHNICIAN_FAILURE,
  FETCH_REPORT_STATUS_FAILURE,
} from './actions';

const initialState = {
  daily_datas: null,
  daily_data: null,
  technician_data: null,
  status_data: null,
  loading: false,
  error: null,
};

const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DAILY_REPORTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DAILY_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_REPORT_TECHNICIAN_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_REPORT_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DAILY_REPORTS_SUCCESS:
      return { ...state, loading: false, daily_datas: action.payload, data: action.payload };
    case FETCH_DAILY_REPORT_SUCCESS:
      return { ...state, loading: false, daily_data: action.payload };
    case FETCH_REPORT_TECHNICIAN_SUCCESS:
      return { ...state, loading: false, technician_data: action.payload };
    case FETCH_REPORT_STATUS_SUCCESS:
      return { ...state, loading: false, status_data: action.payload };

    case FETCH_DAILY_REPORTS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_DAILY_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_REPORT_TECHNICIAN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_REPORT_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default ticketReducer;
